import { CloseOutlined } from '@ant-design/icons'
import React from 'react'

import cn from './ResetFiltersButton.module.scss'

interface ResetFiltersButtonProps {
  selectedOrganisation?: object
  onClick?: () => void
  disabled?: boolean
}

const ResetFiltersButton: React.FC<ResetFiltersButtonProps> = ({
  selectedOrganisation = {},
  onClick,
  disabled = false,
}) => {
  const isOrgSelected = Object.keys(selectedOrganisation).length > 0

  const handleTouchEnd = (e: React.TouchEvent<HTMLButtonElement>) => {
    if (disabled) return
    e.preventDefault()
    onClick?.()
  }

  const handleClick = (_e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) return
    onClick?.()
  }

  const buttonClassName = disabled
    ? cn.disabled
    : isOrgSelected
      ? cn.buttonSelected
      : cn.button

  return (
    <button
      className={buttonClassName}
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      disabled={disabled}
      title="Сбросить фильтры"
    >
      <CloseOutlined />
    </button>
  )
}

export default ResetFiltersButton
